import React from "react";
import { Form, Select, Tag } from "antd";
import type { SelectProps } from "antd";

// Define a type for tag rendering
type TagRender = SelectProps["tagRender"];

// Map your options to colors
const optionColors: Record<string, string> = {
  residentiel: "green",
  professionel: "red",
  commerce: "cyan",
};

// Custom tag rendering function
const tagRender: TagRender = (props) => {
  const { label, value, closable, onClose } = props;

  const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Tag
      color={optionColors[value]}
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      style={{ marginInlineEnd: 4 }}
    >
      {label}
    </Tag>
  );
};

interface Props {
  form: any;
}

const UsageFormItem: React.FC<Props> = ({ form }: any) => (
  <Form.Item
    name="usage"
    label="Usage"
    rules={[
      {
        required: true,
        message: "Veuillez saisir l'usage",
      },
    ]}
  >
    <Select mode="multiple" tagRender={tagRender} style={{ width: "100%" }}>
      <Select.Option value="residentiel">Résidentiel</Select.Option>
      <Select.Option value="professionel">Professionnel</Select.Option>
      <Select.Option value="commerce">Commerce</Select.Option>
    </Select>
  </Form.Item>
);

export default UsageFormItem;
